/**
 * The one chip form every stratum tag wears: colored text + border on
 * a translucent wash of the same paint (the house tint() pattern).
 * Internal to strata -- consumers never style a stratum themselves.
 */
import { Tag, Tooltip } from 'antd';
import type { ReactNode } from 'react';
import { tint } from '../theme';

export function StrataChip({
  paint,
  title,
  children,
}: {
  paint: string;
  title?: string;
  children: ReactNode;
}) {
  const tag = (
    <Tag
      style={{
        color: paint,
        borderColor: paint,
        background: tint(paint, 0.15),
        marginInlineEnd: 0,
      }}
    >
      {children}
    </Tag>
  );
  return title ? <Tooltip title={title}>{tag}</Tooltip> : tag;
}
